module.exports = __webpack_public_path__ + "static/media/ic-uncorrect.88f195e4.svg";